import { Info } from "lucide-react";
import { useTran } from "@/hooks";
import { useDisclosureStore } from "../../hooks/useDataEntryStore";
import { isNxmapMappableDisclosure } from "@/features/esg/constants/nxmap-mappable-disclosures.constants";

const EntryEmptyState = ({ hasCreatePermission = true }) => {
  const { t } = useTran();
  const { activeDisclosure } = useDisclosureStore();
  const { code, framework } = activeDisclosure || {};
  const isNxmapDisclosure = isNxmapMappableDisclosure(framework, code);

  return (
    <div>
      <div className="rounded-md border border-border p-8 text-center">
        {hasCreatePermission ? (
          <p className="text-sm text-muted-foreground">
            {isNxmapDisclosure ? (
              <>
                {t("No data synced from NXMap yet. Click")}{" "}
                <strong>NXMap Bulk Sync</strong>{" "}
                {t("to retrieve and display records.")}
              </>
            ) : (
              <>
                {t("No entries yet. Click")} <strong>+ Add Entry</strong>{" "}
                {t("to begin.")}
              </>
            )}
          </p>
        ) : (
          <p className="text-sm text-muted-foreground">
            {t("No entries yet.")}
          </p>
        )}
      </div>
      <p className="mt-3 flex items-center gap-1.5 text-xs text-muted-foreground">
        <Info size={14} />
        {t("No entries yet")}
      </p>
    </div>
  );
};

export default EntryEmptyState;
